import React from "react";
import { Anchor, Box } from "grommet";
import { IconSvg } from "../IconSvg";
export var SocialMedia = function SocialMedia() {
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      direction: "row",
      align: "center",
      gap: "13px",
    },
    /*#__PURE__*/ React.createElement(Anchor, {
      href: "https://vk.com/mostriathlon",
      icon: /*#__PURE__*/ React.createElement(IconSvg, {
        src: "vk-2",
        color: "black",
      }),
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        padding: "0",
      },
    }),
    /*#__PURE__*/ React.createElement(Anchor, {
      href: "https://t.me/mostriathlon",
      icon: /*#__PURE__*/ React.createElement(IconSvg, {
        src: "telegram",
        color: "black",
      }),
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        padding: "0",
      },
    })
  );
};
